import http from 'plugins/axios';

export default {
  getAppList({page,size,platform,tenantId}) {
    return http.get({
      url:`/la/admin/app/version/list?page=${page}&size=${size}&platform=${platform}&tenantId=${tenantId}`
    })
  },
  //修改后新增
  addApp(data) {
    return http.post({
      url:'/la/admin/app/version/save',
      data,
      
    })
  },
  handleSaveInfo(data) {
    return http.post({
      url:'/la/admin/app/version/update',
      data,
      
    })
  },
   //新增
  // addApp(data) {
  //   return http.post({
  //     url:'/la/admin/app/conf/save',
  //     data,
      
  //   })
  // },
  changeStatusApp({id,status}){
    return http.post({
      url:`/la/admin/app/version/update/status?id=${id}&status=${status}`
    })
  },
  //获取商户id列表
  getTentIdlist(){
    return http.get({
      url:'/la/admin/tenant/info'
    })
  },
  getAppInfo(platform) {
    return http.get({
      url: `/la/admin/app/package/${platform}`,
      dataType: 'form'
    });
  },
  saveAppInfo(data) {
    return http.post({
      url: '/la/admin/save/app/url',
      data,
      dataType: 'form'
    });
  },
  saveVersionAppInfo(data) {
    return http.post({
      url: '/la/admin/save/app/version',
      data,
      dataType: 'form'
    });
  },
  getVersionAppInfo(platform) {
    return http.get({
      url: '/la/admin/get/app/version',
      data: {
        platform
      }
    });
  }
};
